export default "__VITE_ASSET__DZHfDGUF__"